__turbopack_context__.v({
  "analysisContainer": "CallAnalysis-module__T7QWAW__analysisContainer",
  "analysisTitle": "CallAnalysis-module__T7QWAW__analysisTitle",
  "content": "CallAnalysis-module__T7QWAW__content",
  "headerActions": "CallAnalysis-module__T7QWAW__headerActions",
  "librarySection": "CallAnalysis-module__T7QWAW__librarySection",
  "mainBody": "CallAnalysis-module__T7QWAW__mainBody",
  "uploadSection": "CallAnalysis-module__T7QWAW__uploadSection",
});
